import { AxiosInstance } from 'axios';

import { createAxiosInstance } from '@app/common/axios.factory';

const SHARED_ES_AXIOS_INSTANCE_SYMBOL = Symbol.for('nocowanie.ssr.sharedEsAxiosInstance');

type GlobalStore = typeof globalThis & {
    [SHARED_ES_AXIOS_INSTANCE_SYMBOL]?: AxiosInstance;
};

export const getSharedEsAxiosInstance = (): AxiosInstance => {
    const globalStore = globalThis as GlobalStore;

    if (!globalStore[SHARED_ES_AXIOS_INSTANCE_SYMBOL]) {
        globalStore[SHARED_ES_AXIOS_INSTANCE_SYMBOL] = createAxiosInstance();
    }

    return globalStore[SHARED_ES_AXIOS_INSTANCE_SYMBOL] as AxiosInstance;
};
